import React from 'react'
import PropTypes from 'prop-types'
import './index.css'

const CampaignSeal = ({ logo, className }) => <img className={className} alt="campaign-seal-logo" src={logo} />

export default CampaignSeal

CampaignSeal.defaultProps = {
  logo: '',
  className: 'footer_campaign-seal-logo',
}

CampaignSeal.propTypes = {
  logo: PropTypes.string,
  className: PropTypes.string,
}
